import { complement, isNil } from 'ramda';

import { getDateForIms } from '@core/js/hooks/useFormatter/helpers';

import { send } from '@interlayer/js/hooks/socket';

import { TChangeDetailsProps, TCreatePlayerInfoProps, TSendBatchRequestProps } from './types';

export const createPlayerInfo = ({
    casinoName,
    addressDetails,
    contactAddress,
    dataMap,
    token = null,
    blackbox = null
}: TCreatePlayerInfoProps) => send({
    ID: 31007,
    responses: [31008, 33006],
    description: 'Create Player Info (Register)',
    ...casinoName && { casinoName },
    addressDetails,
    contactAddress,
    dataMap,
    ...token && { token },
    ...blackbox && {
        customData: [
            {
                key: 'iovationBlackbox',
                value: blackbox
            }
        ]
    }
});

export const sendBatchRequest = ({
    authParameters,
    contactPreferences,
    tags
}: TSendBatchRequestProps) => send({
    ID: 35508,
    responses: [35516, 35517],
    description: 'Create Player Info (Batch Request)',
    authParameters,
    errorLevel: 1,
    requests: [
        contactPreferences && {
            ID: 35513,
            description: 'Set user contact preferences',
            responses: [35514, 35515],
            contactPreferences,
            errorLevel: 1
        },
        tags && {
            ID: 35544,
            responses: [35545, 35546],
            description: 'Set player tags',
            tags,
            errorLevel: 1
        }
    ].filter(complement(isNil))
});

export const changeDetails = ({
    dataMap,
    addressDetails,
    contactAddress,
    changeTimestamp = getDateForIms(new Date())
}: TChangeDetailsProps) => send({
    ID: 33045,
    description: 'Update player info',
    responses: [33006, 31008],
    changeTimestamp,
    dataMap,
    ...addressDetails && { addressDetails },
    ...contactAddress && { contactAddress }
}, true);
